import { setQueueData } from "../redux/offline/Actions";
import { getStore } from "../redux/setup"

export default class Send {
  static lastCheckTimestamp = null;
  static lastResult = null;
  static debounceDuration = 5000; // 5 segundos

  static online = true;//navigator.onLine
  static server = process.env.REACT_APP_SERVER || "https://be.manejechat.com";

  static setServer(url) {
    this.server = url
  }

  static getHeaders(hasAuth) {
    const token = hasAuth ? getStore().getState().app?.user?.access_token : null;
    return {
      "Content-type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    }
  }

  static formatResponse(response, isJsonResponse = true) {
    if (response && isJsonResponse) {
      return response.json();
    } else if (!isJsonResponse) {
      return response;
    }
    throw new Error("Something went wrong");
  }

  static setOnline(isOnline) {
    this.online = isOnline
  }

  static isOnline() {
    // const controller = new AbortController();
    // const timeoutId = setTimeout(() => controller.abort(), 1000); // Timeout de 1 segundo

    // try {
    //   const response = await fetch('https://be.manejechat.com/', {
    //     method: 'GET',
    //     signal: controller.signal, // Passa o sinal de controle para o fetch
    //   });

    //   clearTimeout(timeoutId); // Cancela o timeout se a resposta chegar antes

    //   if (response.ok) {
    //     const data = await response.json();
    //     return data.status === "OK";
    //   }

    //   return false;
    // } catch (error) {
    //   if (error.name === 'AbortError') {
    //     console.error('Requisição expirada (timeout)');
    //   } else {
    //     console.error('Erro ao verificar o status da API:', error);
    //   }
    // }

    // return false
    return this.online;
  }

  // Obtém cache do Redux
  static getCachedResponse(url) {
    return getStore().getState().cache?.[url] || null;
  }

  // Armazena resposta no cache
  static cacheResponse(url, response) {
    getStore().dispatch({
      type: 'CACHE_RESPONSE',
      payload: { url, response },
    });
  }

  // Adiciona requisição à fila
  static queueRequest(method, url, data) {
    getStore().dispatch(setQueueData({
      method,
      url,
      data
    }))
  }

  // Processa fila de requisições offline
  static processQueue() {
    const queuedRequests = getStore().getState().queue || [];
    queuedRequests.forEach(async ({ method, url, data }) => {
      try {
        await fetch(`${this.server}${url}`, {
          method,
          body: JSON.stringify(data),
          headers: this.getHeaders(true),
        });
      } catch (error) {
        console.error("Failed to process queued request:", error);
      }
    });
    getStore().dispatch({ type: 'CLEAR_QUEUE' });
  }

  // Método GET
  static async get_old(url, suffix = "", hasAuth = true, options = {}) {
    return fetch(`${this.server}${url}?${suffix}`, {
      headers: this.getHeaders(hasAuth),
      timeout: 600000,
      ...options,
    }).then(this.formatResponse);
  }

  // Método GET Offline
  static async get(url, suffix = "", hasAuth = true, options = {}) {
    const fullUrl = `${this.server}${url}?${suffix}`;

    const isOnline = this.isOnline()

    if (isOnline) {
      // Online: realiza a requisição normal e cacheia o resultado
      return this.get_old(url, suffix, hasAuth, options).then(data => {
        this.cacheResponse(fullUrl, data);
        return data;
      });
    } else {
      // Offline: tenta retornar o cache
      const cachedResponse = this.getCachedResponse(fullUrl);
      return cachedResponse
        ? Promise.resolve(cachedResponse)
        : Promise.reject(new Error('No cached data available'));
    }
  }

  // Método POST
  static async post(url, data, hasAuth = true, isJsonResponse = true) {
    return fetch(`${this.server}${url}`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(hasAuth),
    }).then(response => this.formatResponse(response, isJsonResponse));
  }

  // Método POST Offline
  static async postOffline(url, data, hasAuth = true, isJsonResponse = true) {
    const isOnline = this.isOnline()

    if (isOnline) {
      return this.post(url, data, hasAuth, isJsonResponse);
    } else {
      this.queueRequest("POST", url, data);
      return Promise.resolve({ message: "Request queued due to offline status" });
    }
  }

  // Método PUT
  static async put(url, data, hasAuth = true) {
    return fetch(`${this.server}${url}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: this.getHeaders(hasAuth),
    }).then(this.formatResponse);
  }

  // Método PUT Offline
  static async putOffline(url, data, hasAuth = true) {
    const isOnline = this.isOnline()
    if (isOnline) {
      return this.put(url, data, hasAuth);
    } else {
      this.queueRequest("PUT", url, data);
      return Promise.resolve({ message: "Request queued due to offline status" });
    }
  }

  // Método DELETE (mantém inalterado)
  static async delete(url, hasAuth = true) {
    return fetch(`${this.server}${url}`, {
      method: "DELETE",
      headers: this.getHeaders(hasAuth),
    }).then(this.formatResponse);
  }
}
